var exports = {
  "r2": "EditGroupModal.module__iconSection___YmRVa1",
  "go": "EditGroupModal.module__iconLabel___YmRVa1",
  "zc": "EditGroupModal.module__iconContainer___YmRVa1",
  "O2": "EditGroupModal.module__iconPreview___YmRVa1",
  "Pz": "EditGroupModal.module__iconPlaceholder___YmRVa1",
  "So": "EditGroupModal.module__iconPlaceholderIcon___YmRVa1",
  "D_": "EditGroupModal.module__iconActions___YmRVa1",
  "Rh": "EditGroupModal.module__iconButtonGroup___YmRVa1",
  "m5": "EditGroupModal.module__iconError___YmRVa1",
};

module.exports = exports;
